import styles from './myButton.module.css';

const MyButton = ({ label, onClick, icon = null, style, iconStyle }) => {
  return (
    <button style={style} onClick={onClick} className={styles.buttonSecondary}>
      {icon && <i style={iconStyle} className={`${icon} ${styles.icon}`} />}
      {label}
    </button>
  );
};

export default MyButton;
